import { useEffect } from 'react';
import { captureAttribution } from '../utils/attribution';

const STORAGE_KEY = 'romy_referral_code';
const CODE_PATTERN = /^[A-Za-z0-9]{6,12}$/;

/**
 * Captures `?ref=CODE` from the URL on page load,
 * stores it in sessionStorage, and strips the param from the URL.
 * Also captures first-touch acquisition attribution (UTM params + referrer).
 */
export function useReferralCapture() {
  useEffect(() => {
    // Record first-touch attribution before we strip any params below.
    captureAttribution();

    const params = new URLSearchParams(window.location.search);
    const code = params.get('ref');

    if (code && CODE_PATTERN.test(code)) {
      sessionStorage.setItem(STORAGE_KEY, code);

      // Strip ref param from URL without reload
      params.delete('ref');
      const newSearch = params.toString();
      const newUrl =
        window.location.pathname +
        (newSearch ? `?${newSearch}` : '') +
        window.location.hash;
      window.history.replaceState({}, '', newUrl);
    }
  }, []);
}
